import { useCoaches } from '@/data/coach';
import Loader from '@/components/common/Loader';
import CoachCard from '@/app/coach/CoachCard';

const FavouriteCoachesList = () => {
  const coaches = useCoaches({
    favouritedBy: 'self'
  });

  if (coaches.isLoading && !coaches.data) {
    return (
      <div className="flex justify-center items-center h-[calc(100vh-180px)]">
        <Loader />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 pb-8">
      {coaches.data.map((coach) => (
        <CoachCard key={coach.id} coach={coach} />
      ))}
    </div>
  );
};

export default FavouriteCoachesList;
